import { Flex, Typography } from 'antd';
import { AutoSizer } from 'react-virtualized';
import _ from 'lodash';
import React from 'react';
import { Pie } from '@nivo/pie';

interface IRenderedPieChart {
	rows?: string;
	label?: string;
	value?: string;
	title?: string;
}


export default function RenderedPieChart({ rows, title, label, value, }:IRenderedPieChart) {
    
	const data = React.useMemo(() => {
		try {
			const _rows = JSON.parse(rows ?? '') as ({[key: string]: string | number })[];

			if(!_rows) return [];
			if(!label || !value) return [];
			if(!Object.keys(_rows?.at(0) ?? {}).includes(label) 
                || !Object.keys(_rows?.at(0) ?? {}).includes(value)) return [];

			const groupedByXAxis = _.groupBy(_rows, label);
			return Object.keys(groupedByXAxis).map((key) => {
				const rows = groupedByXAxis[key];
				const sum = rows.reduce((acc, row) => acc + +(row[value] ?? 0), 0);
  
				return {
					id: key,
					label: key,
					value: sum ?? 0,
				};
			});

			
		}
		catch (error) {
			return [];
		}
	}, [ label, value, rows, ]);

	return (
		<Flex vertical style={{
			width: '100%',
			height: '100%',
			flex: 1,
			padding: 12,
			overflow: 'hidden',
		}}
		>
			<Typography.Title level={4}>{title}</Typography.Title>
			<AutoSizer>
				{({ height, width, }) => (
					<Pie
						width={width}
						height={height}
						animate={false}
						data={data ?? []}
						innerRadius={0.5}
						margin={{ bottom: 50, right: 50, top: 15, left: 50, }}
						colors={{ scheme: 'tableau10', }}
						arcLabelsTextColor={'white'}
						enableArcLinkLabels={true}
						arcLinkLabelsStraightLength={3}
						arcLinkLabelsDiagonalLength={8}
					/>
				)}
			</AutoSizer>
			
		</Flex>
	);
}
